import PropTypes from 'prop-types'
import { camelize } from 'util/strings'
import { keys, hasProp } from 'util/objects'

export const t = PropTypes.shape({
  unifiedInbox: PropTypes.bool,
  defaultReplyState: PropTypes.oneOf(['open', 'closed']),
  openFolderOnTicketReply: PropTypes.bool,
  openFolderOnNoteAdd: PropTypes.bool,
  reassignTicketOnReply: PropTypes.bool,
  reassignTicketOnNote: PropTypes.bool,
  prefersAgentsCanMoveToInaccessibleMailboxes: PropTypes.bool,
  undoSendDelay: PropTypes.number,
})

export function fromGQLPayload(preferences = {}) {
  return keys(preferences).reduce((newObject, key) => {
    newObject[camelize(key)] = preferences[key] // eslint-disable-line no-param-reassign
    return newObject
  }, {})
}

export function maybeFromGQL(preferences = {}) {
  if (hasProp('defaultReplyState')) return preferences
  return fromGQLPayload(preferences)
}

export function repliesAsOpen(preferences = {}) {
  return maybeFromGQL(preferences).defaultReplyState === 'opened'
}
